<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <ui-modal
    id="zendesk_error_modal"
    ref="zendesk_error_modal"
    buttons-appearance="primary"
    no-cancel
    :shown="alertShown"
    align-center
    :label-confirm="i18n.tryAgain"
    :handle-confirm="handleOpen"
    @close="alertShown = false"
  >
    <template #header>
      <span>{{ i18n.title }}</span>
    </template>
    <template #body>
      {{ i18n.body }}
    </template>
    <template #icon>
      <svg-alert-error></svg-alert-error>
    </template>
  </ui-modal>
  <div
    id="zendesk-chatbot-handler"
    @click="handleOpen"
  >
    <SvgChatBot :hide-path="open" />
  </div>
</template>

<script setup>
  import { ref, defineAsyncComponent } from 'vue'
  import ApiResponse from '../services/api-response'
  import ZendeskJWTHttpResponseDTO from '../services/subscriptions/dtos/zendesk-jwt-http-response-dto'

  const SvgChatBot = defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "chunk-svg-chat-bot", webpackMode: "eager"  */ './svg/chat-bot.vue'
      )
  )
  const UiModal = defineAsyncComponent(
    () =>
      import(/* webpackChunkName: "chunk-ui-modal", webpackMode: "eager"  */ './ui/ui-modal.vue')
  )
  const SvgAlertError = defineAsyncComponent(
    () =>
      import(
        /* webpackChunkName: "chunk-feedback-error", webpackMode: "eager"  */ './svg/feedback-error.vue'
      )
  )

  const i18n = {
    title: gettext('Oops! Something went wrong!'),
    tryAgain: gettext('Try again'),
    body: gettext(
      'Looks like something didn’t go as planned. No worries, just give it another shot!'
    ),
  }

  const open = ref(false)
  const loading = ref(false)
  const alertShown = ref(false)

  async function handleOpen() {
    if (
      loading.value ||
      open.value ||
      typeof window.__APP_CONFIG__ !== 'object' ||
      typeof window.__APP_CONFIG__.ZENDESK_KEY !== 'string' ||
      typeof window.__APP_CONFIG__.ZENDESK_JWT_URL !== 'string'
    ) {
      return
    }
    alertShown.value = false
    loading.value = true
    try {
      const response = await window.$http.get(window.__APP_CONFIG__.ZENDESK_JWT_URL, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        withCredentials: true,
      })
      const apiResponse = new ApiResponse(response)
      const data = apiResponse.toModel(ZendeskJWTHttpResponseDTO)

      const JWT_TOKEN = data.jwt

      const s = document.createElement('script')
      s.id = 'ze-snippet'
      s.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + window.__APP_CONFIG__.ZENDESK_KEY
      s.async = true

      s.onload = function () {
        window.zE('messenger', 'loginUser', function (callback) {
          callback(JWT_TOKEN)
          window.zE('messenger', 'open')
          setTimeout(() => {
            open.value = true
          }, 500)
        })
      }

      document.head.appendChild(s)
    } catch {
      alertShown.value = true
    } finally {
      loading.value = false
    }
  }
</script>

<style>
  #zendesk-chatbot-handler {
    position: fixed;
    right: 16px;
    bottom: 16px;
    cursor: pointer;
    z-index: 9997;
  }
</style>
